<template>
  <div>
    <v-autocomplete
      :items="items"
      item-text="text"
      item-value="id"
      v-model="contextModel"
      :label="$t('components.ajaxBookingFlightSelect.label')"
      append-icon="flight"
      :error-messages="validationMessage"
      @focus="openDialog"
      :menu-props="{ value: false }"
    >
      <template slot="selection" slot-scope="data">
        <v-chip small :selected="data.selected" :key="JSON.stringify(data.item)" @click="openDialog">
          {{ data.item.text }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-dialog v-model="dialog" persistent max-width="1400px">
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">{{ $t("components.ajaxBookingFlightSelect.flightBookingList") }}</span>
        </v-card-title>

        <booking-flight-data-table :search="search">
          <div slot="action-column" slot-scope="item">
            <v-btn icon class="ma-0" disabled v-if="isWNBUser" :title="$t('components.ajaxBookingFlightSelect.showBookingDetails')">
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <v-tooltip z-index="500" top>
              <template #activator="{on}">
                <v-btn v-on="on" icon class="ma-0" @click.native="assignBooking(item.booking)" :disabled="$store.getters['Ajax/loading']">
                  <v-icon>mdi-pin</v-icon>
                </v-btn>
              </template>
              {{ $t("components.ajaxBookingFlightSelect.pinBooking") }}
            </v-tooltip>

            <v-tooltip z-index="500" top>
              <template #activator="{on}">
                <v-btn
                  v-if="isRouteTo(item.booking)"
                  @click.native="importRouteTo(item.booking)"
                  icon
                  class="ma-0"
                  v-on="on"
                  :disabled="$store.getters['Ajax/loading']"
                >
                  <v-icon>flight_takeoff</v-icon>
                </v-btn>
              </template>
              {{ $t("components.ajaxBookingFlightSelect.importRoute") }}
            </v-tooltip>

            <v-tooltip z-index="500" top>
              <template #activator="{on}">
                <v-btn
                  v-on="on"
                  v-if="isRouteBack(item.booking)"
                  @click.native="importRouteBack(item.booking)"
                  icon
                  class="ma-0"
                  :disabled="$store.getters['Ajax/loading']"
                >
                  <v-icon>flight_land</v-icon>
                </v-btn>
              </template>
              {{ $t("components.ajaxBookingFlightSelect.importReturnRoute") }}
            </v-tooltip>
          </div>
        </booking-flight-data-table>

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayOfWeek from "../../repository/shortDayOfWeekFromDate";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import formatDateView from "../../repository/fotmatDateView";
import BookingFlightDataTable from "../Booking/BookingFlightDataTable.vue";

export default {
  name: "AjaxBookingFlightSelect",
  components: { BookingFlightDataTable },
  props: {
    readonly: {
      required: false,
      default: false
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      required: true
    },
    fileId: {
      required: false,
      default: null
    },
    ticketNumber: {
      required: false,
      default: null
    }
    //search: null,
  },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    //items: [],
    search: "",
    uploadedFile: null,
    //loading: false,

    pagination: {
      sortBy: "bookingDateTime",
      descending: false
    },
    loading: false
    //items: []
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    },
    model(val) {
      if (val != null) {
        this.items.push({ id: this.model, text: "" + this.ticketNumber });
      }
    },
    dialog() {
      document.activeElement.blur();
    }
  },
  computed: {
    items() {
      if (this.model != null) {
        return [{ id: this.model, text: "" + this.ticketNumber }];
      }
      return [];
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    isWNBUser() {
      return this.$store.getters["isWnbUser"];
    }
  },
  methods: {
    openDialog() {
      if (this.readonly !== true) {
        this.dialog = true;
      }
    },
    isRouteTo(item) {
      return item.flightAttributes.start_date != null;
    },
    isRouteBack(item) {
      return item.flightAttributes.return_start_date != null;
    },
    assignBooking(item) {
      this.$emit("update:model", item.id);
      this.$emit("update:ticketNumber", item.flightAttributes.airline_name + " " + item.ticket_number);
      let self = this;
      this.axios.get("delegation/get-booking-file?bookingId=" + item.id).then(resp => {
        self.$emit("fileRemoved", { id: self.contextFileId });
        this.contextFileId = resp.data.file_id;
        const newItem = {
          id: resp.data.file_id,
          itemName: resp.data.file_name,
          status: this.$t("global.generatedServerSide"),
          fileSize: 0,
          uploadedSize: 0
        };
        self.$emit("fileUploaded", newItem);
        self.$emit("update:fileId", resp.data.file_id);
      });
      this.dialog = false;
    },
    importRouteTo(item) {
      this.$emit("importRouteTo", item);
      this.assignBooking(item);
    },
    importRouteBack(item) {
      this.$emit("importRouteBack", item);
      this.assignBooking(item);
    },
    dayOfWeek: dayOfWeek,
    filterOverAllProperty: filterOverAllProperty,
    formatDateView: formatDateView
  },
  created() {},
  beforeDestroy() {
    this.$emit("update:model", null);
    this.$emit("update:ticketNumber", null);
    this.$emit("fileRemoved", { id: this.contextFileId });
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}

.flight-direction {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.grey--text {
  color: #9e9e9e !important;
}

.bigger {
  margin-right: 4px;
  font-size: 15px;
}

.flight-airport {
  font-weight: 700;
  line-height: 1;
}
</style>
